import { useState } from '@hookstate/core';

import { ReactComponent as NewFilter } from '@assets/svg/new-filter.svg';
import { IFilter } from '@pages/Products/Products';
import { CSSTransition } from 'react-transition-group';
import { countFilter } from '@utils/countFilter/getFilterRequest';
import { ClickAwayListener } from '@material-ui/core';
import { GlobalOverlay } from '@components';
import { FilterContent } from './components';

import { Container, ButtonAddField, Block, CircleDiv } from './Filter.styles';

interface FilterProps {
  filterData: IFilter;
  startSearch: () => void;
  onClick?: () => void;
}

const Filter = ({ filterData, startSearch, onClick }: FilterProps) => {
  const open = useState(false);
  const filterCount = countFilter(filterData);
  const handleClickAway = () => {
    if (open.value) open.set(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Container>
        <ButtonAddField
          onClick={() => {
            open.set(true);
            if (onClick) onClick();
          }}
        >
          <NewFilter />
        </ButtonAddField>
        {filterCount > 0 && <CircleDiv>{filterCount}</CircleDiv>}
        {open.get() && <GlobalOverlay onClick={handleClickAway} />}
        <CSSTransition
          in={open.get()}
          timeout={300}
          classNames="my-node"
          unmountOnExit
          onEnter={() => open.set(true)}
          onExited={() => open.set(false)}
        >
          <Block>
            <FilterContent
              openAddField={open}
              filterData={filterData}
              startSearch={startSearch}
              filterCount={filterCount}
            />
          </Block>
        </CSSTransition>
      </Container>
    </ClickAwayListener>
  );
};

export { Filter };
